export default "../src/img/ajax-loader.gif";